module.exports = __webpack_public_path__ + "0b3a20b2a7dc52902646f196e32f907e.svg";